export default __webpack_public_path__ + "static/media/escalation-red.34dc53a2.svg";